var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _ellipse, _path10, _path11, _ellipse2, _path12, _path13, _path14, _path15, _path16, _path17, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGuuruShrugs = function SvgGuuruShrugs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "20.14cm",
    height: "14.38cm",
    viewBox: "0 0 570.79 407.56"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "GuuruShrugs_svg__linear-gradient",
    x1: 297.44,
    x2: 297.44,
    y1: 377.92,
    y2: 377.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#5f6767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#686b6c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#717475"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#87898a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#949798"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#999b9c"
  })), /*#__PURE__*/React.createElement("style", null, ".GuuruShrugs_svg__cls-2{fill:#00b0f0}.GuuruShrugs_svg__cls-4{fill:#3bb8d9}.GuuruShrugs_svg__cls-5{fill:#cff5ff}.GuuruShrugs_svg__cls-7{fill:#fff}.GuuruShrugs_svg__cls-8{fill:#e3e329}.GuuruShrugs_svg__cls-9{fill:#8b8b8b}"))), /*#__PURE__*/React.createElement("g", {
    id: "GuuruShrugs_svg__Hauptillu"
  }, /*#__PURE__*/React.createElement("g", {
    id: "GuuruShrugs_svg__Ebene_9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m204.81 330.3-.61-6.48s10.27 8.89 37.07-1.22c18.53-7 31.68-.87 34.33.61 15.2 8.51 29.32 12.61 41.48 5.93l-3.72 21.19-41.1-1.19s-30.69-14.48-67.45-18.84",
    style: {
      fill: "#a31d24"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M309.55 62.57S305.29 34 262.76 35.22c0 0-46.8 0-58.34 45s-35.84 36.26-34.64 65.64c1.21 29.77 21.87 18.23 26.13 41.93s-35.86 38.89 1.21 63.2c0 0 65 55.3 164.69-6.08 0 0 55.38-31.69 5.47-75.35-9.72-8.51-17.62-12.16-3-43.15s-24.95-76.6-54.73-63.84",
    className: "GuuruShrugs_svg__cls-2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M229.5 125.77s-23.4 16.11-20.83 41.93c1.32 13.31 3.65 28-20 43.76-19.64 13.09-7.3 35.85 8.5 39.5 0 0 69.28 43.14 164.69-6.08 0 0 62-32.21 1.82-79-8.05-6.27-39.63-17.62-45.1-41.32",
    style: {
      fill: "#1067a1"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m421.37 239.05 30.63-8.71a21.07 21.07 0 0 1-9.11 15.39l5.87 3.65",
    className: "GuuruShrugs_svg__cls-4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M257.65 177.67s2.63 32.21-5.27 38.89-35.81 12.76-35.81 12.76 58.34 59.56 124.58-1.21c0 0-31-4.26-38.89-11.55s-6.69-44.36-6.69-44.36",
    className: "GuuruShrugs_svg__cls-5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M257.53 177.67c0 3.24 2.16 30.46-4.3 37.27-7.39 7.8-30.58 11.95-30.58 11.95C250.6 255.45 264 245.12 264 245.12s-28.51-12.72-6.68-20.66c7.47-2.72 10-4.32 10.79-9.87a6.74 6.74 0 0 1 7.47-5.73c11.1 1.4 21.95-4.93 21.95-4.93l-4.16-29.58",
    className: "GuuruShrugs_svg__cls-4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M290.1 74.72S233 65 232.37 119.09c0 0 2.43 26.74 1.82 32.2-.55 5-6.07 27.3 28 46.37a29.29 29.29 0 0 0 26.92.84c12.61-6 28.38-17.82 29.95-43.29.24-3.89.54-7.77 1-11.64 1.94-16.06 4.15-59.95-29.96-68.85",
    className: "GuuruShrugs_svg__cls-5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M266.1 108.39s4.56 6.64 6.18 21.84c1 9.32-6.89 26.94-6.89 26.94l15.8.2-13.45 5.63a8.78 8.78 0 0 0 .4 8c.2.35 19.89 4.93 19.89 4.93s2 8.26-18.24 7.86c0 0-4.05 9.92 3.3 17.92 0 0-39.71-4.86-40.92-51.25l-2.84-24.67s9.12-21.96 36.77-17.4",
    className: "GuuruShrugs_svg__cls-4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M279.16 59.53c-66-6.39-71.1 46.79-68.06 56.52a24 24 0 0 0 11.11 13.67c7.9-.61 26.25-25.29 33.25-32.51 20.06-20.66 41.93-14.59 41.93-14.59s8.38 54.7 47.27 60.17c0 0-.3-11.25 2.13-18.54s-10.5-47.7-43.32-50.74c0 0-5.47-12.16-24.31-13.98",
    className: "GuuruShrugs_svg__cls-2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m381.26 296.17 40.11-57.12s15.19 5.46 25.52 5.46c27.37 0 32.12-5.95 34.55-7.16s-6.81 17.7-21.79 21.14c-12.68 2.91-27.64-.92-31 2.43-3.65 3.65-31.6 86.9-59 104.53L341.76 315Z",
    className: "GuuruShrugs_svg__cls-5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M381.26 296.17s-18.4 37.7-11.55 69.28c.19.85-32.21-57.32-32.21-57.32Z",
    className: "GuuruShrugs_svg__cls-4"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M223.25 225.78s50.44 46.18 114.25 0c0 0 43.71 9.37 50.09 61.48l-6.33 9-39.5 18.84-6.31 35.22-41.09-1.19s-37.07-19.45-67.46-18.84l-1.82-20.05s-46.8-17-48-20.66c-.01.01 6.22-59.09 46.17-63.8",
    style: {
      fill: "#ef4136"
    }
  }), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M281.49 280.6c-47.87 0-87.35-36.5-87.75-36.89l1.91-2c.42.39 42.38 39.18 91.7 35.94 27-1.76 51.3-15.65 72.32-41.27l2.16 1.77c-21.53 26.25-46.53 40.48-74.31 42.3-2.03.09-4.03.15-6.03.15",
    className: "GuuruShrugs_svg__cls-7"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M284.51 138.94c-.34.54 5.74 3.83 22.89.4 1-.2-1.82-2.23-1.82-2.23s-14.26-9.21-21.07 1.83M281.9 109.72s-2.68 8.8 8.81 8c18.73-1.25 22.69 13.08 22.69 13.08s-.1-19.55-31.5-21.08M230.37 132c-.91.6-14.59 17.32 1.82 37.37l8.51 8.51",
    className: "GuuruShrugs_svg__cls-4"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 229.03,
    cy: 172.55,
    className: "GuuruShrugs_svg__cls-7",
    rx: 9.33,
    ry: 9.41,
    transform: "rotate(-83.2 229.028 172.554)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M229.05 183.66a12 12 0 0 1-1.34-.08 11.16 11.16 0 0 1-9.8-12.35 11.19 11.19 0 1 1 11.14 12.43m-7.61-12a7.64 7.64 0 1 0 8.48-6.59 7.61 7.61 0 0 0-8.48 6.59",
    className: "GuuruShrugs_svg__cls-8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M321.05 131.36c.91.62 14.59 17.65-1.82 38.08l-8.51 8.67",
    className: "GuuruShrugs_svg__cls-5"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 322.18,
    cy: 172.41,
    className: "GuuruShrugs_svg__cls-7",
    rx: 9.33,
    ry: 9.41,
    transform: "rotate(-83.2 322.178 172.413)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M322.21 183.52a12 12 0 0 1-1.34-.08 11.16 11.16 0 0 1-9.8-12.35 11.19 11.19 0 1 1 11.14 12.43m-7.61-12a7.63 7.63 0 1 0 8.48-6.59 7.61 7.61 0 0 0-8.48 6.59",
    className: "GuuruShrugs_svg__cls-8"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m144.66 236.54-30.58-8.72a21.08 21.08 0 0 0 9.11 15.4l-5.87 3.65",
    className: "GuuruShrugs_svg__cls-4"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m184.77 293.66-40.11-57.12S129.47 242 119.14 242c-27.37 0-32.12-5.95-34.55-7.16s6.81 17.7 21.79 21.14c12.68 2.91 27.64-.92 31 2.43 3.65 3.65 31.6 86.9 58.95 104.53l27.54-51.77Z",
    className: "GuuruShrugs_svg__cls-5"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M184.77 293.66s18.4 37.7 11.55 69.28c-.19.85 28.54-52.77 28.54-52.77Z",
    className: "GuuruShrugs_svg__cls-4"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M172.42 380.6s-1.36 2.55 8.35 4.67h203.36s6.8-.43 8.59-3.64v-1.76Z",
    className: "GuuruShrugs_svg__cls-9"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M172.47 377.72H392.8v3.77s.33.76-2.26.57h-216s-2 .57-2.22-.75Z",
    style: {
      fill: "#eee"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.44 377.92v-.07a.2.2 0 0 0 0 .07",
    style: {
      fill: "url(#GuuruShrugs_svg__linear-gradient)"
    }
  }), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M371.15 382.41V275.08a3.54 3.54 0 0 0-3.54-3.54h-170a3.54 3.54 0 0 0-3.54 3.54v107.33Z",
    className: "GuuruShrugs_svg__cls-9"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 282.59,
    cy: 330.43,
    r: 7.02,
    className: "GuuruShrugs_svg__cls-7"
  })))));
};
export default SvgGuuruShrugs;